import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { UiModule } from '../ui';
import { SharedUiModule } from '../../shared/ui';
import { ReactiveFormsModule, FormsModule } from '@angular/forms';
import { HttpClientModule } from '@angular/common/http';
import { RouterModule } from '@angular/router';

import { UserService } from './user.service';
import { UserListComponent } from './user-list.component';
import { UserEditComponent } from './user-edit.component';
import { UserAuthComponent, UserDetailsComponent, UserAdminComponent, UserExtrasComponent } from './form';

@NgModule({
  imports: [
    BrowserModule,
    SharedUiModule,
    UiModule,
    ReactiveFormsModule,
    FormsModule,
    HttpClientModule,
    RouterModule
  ],
  declarations: [
    UserListComponent,
    UserEditComponent,

    UserAuthComponent,
    UserDetailsComponent,
    UserAdminComponent,
    UserExtrasComponent
  ],
  exports: [
    UserAuthComponent,
    UserDetailsComponent,
  ],
  providers: [
    UserService
  ],
})
export class UserModule { }
